require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-region-اسيا.json") })
        }
      }, "path---ar-eg-region-اسيا");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-region-اسيا!./.cache/json/ar-eg-region-اسيا.json
// module id = 441
// module chunks = 231608221292675